import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class MatchingService {
  constructor(private http: HttpClient) { }

  newCount() {
    return this.http.get<any>(environment.app.apiUrl + 'matching/news', { context: SharedService.NO_LOADING_BAR }).toPromise();
  }
  jobAlertNewCount(fromDateTicks?: number, toDateTicks?: number) {
    const params: any = { cb: Date.now() };
    if (toDateTicks)
      params['to-date'] = toDateTicks;

    return this.http.get<any>(environment.app.apiUrl + `matching/job-alert-news/${fromDateTicks || ''}`, { params }).toPromise();
  }

  sendAlert(payload: any) {
    return this.http.post<{ [code: string]: boolean }>(environment.app.apiUrl + 'matching/alert', payload).toPromise();
  }

  deleteAlert(alertId: any) {
    return this.http.post(environment.app.apiUrl + 'matching/delete-alert/' + alertId, null).toPromise();
  }

  getUsers(payload: any) {
    return this.http.post<any>(environment.app.apiUrl + 'matching/user', payload).toPromise();
  }

  getSearchCounts(payload: any) {
    return this.http.post<any>(environment.app.apiUrl + 'matching/counts', payload).toPromise();
  }

  alertCount(jobId: string) {
    return this.http.get<any>(environment.app.apiUrl + `matching/alert-count/${jobId}`).toPromise();
  }

  alertReport(jobId: string) {
    return this.http.get<any>(environment.app.apiUrl + `matching/alert-report/${jobId}`).toPromise();
  }

  batchJobs(to: string, batchId: string) {
    if (!batchId) return;
    return this.http.post<any[]>(environment.app.apiUrl + `matching/batch/${batchId}`, { to }).toPromise();
  }
}
